import type { AppMeta, MetaEntity } from '@clientline/contracts';
import type { AdminPageAccessRule } from '../../registry.ts';

/** Право керувати довідником тегів (чутливе: step-up, лише сесія людини; autonumber-tags.md, розд. 2.3). */
export const TAGS_MANAGE = 'tags.manage';

/** Сутність з увімкненою поведінкою `tags` (`/meta`, `entity.behaviors.tags`). */
export const hasTags = (entity: MetaEntity): boolean => Boolean(entity.behaviors?.tags);

/**
 * Хто бачить сторінку `tags`: право `tags.manage` і хоч одна сутність з тегами. Без права немає ні
 * пункту меню, ні коду сторінки; прямий перехід — стан «розділ недоступний» (`AdminSection`).
 */
export default {
  group: 'data',
  permission: (meta: AppMeta) =>
    meta.permissions.includes(TAGS_MANAGE) && meta.entities.some(hasTags),
} satisfies AdminPageAccessRule;
